import { i18n } from "services/i18nService";
import {
  PRIVATE_APP_ID,
  CONNECTOR_APP_ID,
  APP_CREDS_ID,
} from "services/sosInventoryService/cart/schema";
import { isPersistedRecord } from "services/utility/misc";

import { initialErrorState } from "views/common";

function getAuthorizationField1ErrorMessage(record) {
  switch (record.connectionType) {
    case "Shopify":
      return record.shopifyAppType === PRIVATE_APP_ID
        ? i18n("isValid.cart.ShopifyApiKey")
        : i18n("isValid.cart.AdminApiAccessToken");
    case "BigCommerce":
      return i18n("isValid.cart.BigCommerceClientId");
    default:
      break;
  }
}

export function isValid(record) {
  const errors = initialErrorState();

  const isPayPal = record?.connectionType === "PayPal";
  const isBigCommerce = record?.connectionType === "BigCommerce";
  const isShopify = record?.connectionType === "Shopify";
  const isShopifyConnector =
    isShopify && record?.shopifyAppType === CONNECTOR_APP_ID;
  const isAppCreds = isShopify && record?.shopifyAppType === APP_CREDS_ID;

  if (!record.name || !record.name.trim().length) {
    errors.messages.push(i18n("isValid.Name"));
    errors.entity.push("name");
  }

  if (!record.location) {
    errors.messages.push(i18n("isValid.Location"));
    errors.entity.push("location");
  }

  if (!record.txnType) {
    errors.messages.push(i18n("isValid.cart.TxnType"));
    errors.entity.push("txnType");
  }

  if (!isPayPal && !isShopifyConnector && !isAppCreds && !record.authorizationField1) {
    errors.messages.push(getAuthorizationField1ErrorMessage(record));
    errors.entity.push("authorizationField1");
  }

  if (isAppCreds) {
    if (!record.authorizationField1) {
      errors.messages.push(i18n("isValid.cart.ShopifyClientId"));
      errors.entity.push("authorizationField1");
    }
    // Require secret only on new records; blank on edit = keep existing
    if (!isPersistedRecord(record.id) && !record.authorizationField2) {
      errors.messages.push(i18n("isValid.cart.ShopifyClientSecret"));
      errors.entity.push("authorizationField2");
    }
  }

  if (isBigCommerce && !record.storeIdentifier) {
    errors.messages.push(i18n("isValid.cart.BigCommerceApiPath"));
    errors.entity.push("storeIdentifier");
  }

  if (isShopify) {
    if (!record.storeIdentifier) {
      errors.messages.push(i18n("isValid.cart.Shop"));
      errors.entity.push("storeIdentifier");
    }

    if (
      record.shopifyAppType === PRIVATE_APP_ID &&
      !record.authorizationField2
    ) {
      errors.messages.push(i18n("isValid.cart.ShopifyApiPassword"));
      errors.entity.push("authorizationField2");
    }
  }

  return errors;
}
